<template>
    <form
        @submit="submit"
        class="relative flex w-full max-w-[443px] flex-shrink"
    >
            <input
                aria-label="email"
                class="bg-transparent block w-full rounded pl-6 pr-10 sm:text-sm border-2 border-xp-electron-green/30 focus:border-xp-electron-green/50 focus:ring-0 uppercase text-sm font-bold tracking-[2.5px] text-xp-light-grey"
                type="email"
                name="subscription_email"
                v-model="email"
                placeholder="Your email address"
                required
            >
            <button
                class="absolute inset-y-0 right-0 pr-4 flex items-center focus:outline-none"
                aria-label="Submit"
            >
                <svg width="39" height="13" viewBox="0 0 39 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.2681 11.7753L37.311 6.88764L32.2681 2.00001" stroke="white" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M35.8599 7L2 6.99994" stroke="white" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round"/>
                </svg>
            </button>
    </form>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Subscription',
    props: {
        endpoint: {
            required: true,
            type: String,
        }
    },
    data: () => ({
        email: '',
    }),
    methods: {
        submit(e) {
            e.preventDefault()

            axios.post(
                this.endpoint,
                {
                    email: this.email,
                }
            )
            .then(() => {
                this.$toastr.s("Subscription successful");
            })
            .catch(()=> {
                this.$toastr.e("Error, that email provider is not allowed");
            })
            .then(() => {
                this.resetState()
            })
        },
        resetState(){
            this.email = ''
        }
    },
    computed: {}
}
</script>
